import clsx from 'clsx';
import React from 'react';

enum FieldTypes {
  BOX = 'box',
  NUMBER = 'number',
}

enum BorderTypes {
  FULL = 'full',
  SHORT = 'short',
}

export interface FeatureOfferBoxProps {
  title: string;
  subtitle?: string;
  description?: string;
  fieldType?: FieldTypes;
  borderType?: BorderTypes;
}

export const MktFeaturedOfferBox: React.FC<FeatureOfferBoxProps> = ({
  fieldType = 'box',
  borderType = 'short',
  title,
  description,
  subtitle,
}) => {
  if (fieldType === FieldTypes.NUMBER) {
    return (
      <div className="wh-min-h-[60px] wh-w-[133px] wh-px-[10px] lg:wh-w-[176px]">
        <p className="wh-font-sans wh-text-4xl wh-font-bold wh-text-accent-700 lg:wh-text-7xl">
          {title}
        </p>
      </div>
    );
  }

  return (
    <div
      className={clsx(
        `wh-relative wh-flex wh-min-h-[60px] wh-flex-col wh-gap-[10px]
      lg:wh-w-[176px] lg:wh-gap-[12px]`,
        { 'after:wh-h-[20px]': borderType === BorderTypes.SHORT },
        { 'after:wh-h-full': borderType === BorderTypes.FULL },
      )}
    >
      <div>
        <p className="wh-text-xs wh-font-medium wh-leading-[32px] wh-tracking-[0.32px] wh-text-gold lg:wh-text-base">
          {title}
        </p>
      </div>
      <div>
        <p className="wh-text-base wh-font-medium wh-text-blue-dark lg:wh-text-xl">
          {subtitle}
        </p>
        {description && (
          <p className="wh-pt-[2px] wh-text-[10px] wwh-text-blue-dark lg:wh-text-sm">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};
